<template>
  <div>
    <div v-if="isReady">
      <v-hover #default="{hover}">
        <v-navigation-drawer
          ref="nav"
          class="app-drawer primary"
          app
          floating
          dark
          :mobile-break-point="$vuetify.breakpoint.thresholds.sm"
          :mini-variant="miniDrawer && !hover"
          v-model="showDrawer"
        >
          <v-list>
            <v-list-item>
              <img
                :src="
                  require('@/assets/' +
                    (miniDrawer && !hover ? 'icon' : 'logo') +
                    '.svg')
                "
                alt="МОБИКА"
                :height="miniDrawer && !hover ? '48px' : '37px'"
              />
            </v-list-item>
          </v-list>
          <MainMenu> </MainMenu>
          <AppFooter v-if="!miniDrawer || hover" />
        </v-navigation-drawer>
      </v-hover>
      <AppToolbar :flat="onTop" @menu="onMenu" />
      <v-content v-scroll="onScroll">
        <keep-alive>
          <router-view :key="$route.fullPath" />
        </keep-alive>
        <v-fab-transition>
          <v-btn
            v-if="!onTop"
            fixed
            bottom
            right
            fab
            small
            @click="$vuetify.goTo(0)"
          >
            <v-icon>arrow_upward</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-content>
    </div>
    <v-overlay :value="!isReady || overlay">
      <v-progress-circular indeterminate />
    </v-overlay>
  </div>
</template>

<script>
import MainMenu from "@/components/menu/MainMenu";
import AppToolbar from "@/components/ui/AppToolbar";
import AppFooter from "@/components/ui/AppFooter";
export default {
  name: "AdminLayout",
  components: {
    MainMenu,
    AppToolbar,
    AppFooter
  },
  data() {
    return {
      offsetTop: 0,
      showDrawer: this.$vuetify.breakpoint.mdAndUp,
      miniDrawer: this.$vuetify.breakpoint.md
    };
  },
  methods: {
    onScroll() {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
    },
    onMenu() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        this.showDrawer = true;
        this.miniDrawer = !this.miniDrawer;
      } else {
        this.miniDrawer = false;
        this.showDrawer = !this.showDrawer;
      }
    }
  },
  computed: {
    overlay() {
      return false; //this.$store.state.overlay;
    },
    onTop() {
      return this.offsetTop == 0;
    },
    isLogged() {
      return this.$store.getters["auth/isLogged"];
    },
    isReady() {
      return !!this.$store.getters["auth/getUser"];
    }
  },
  watch: {
    isLogged(v) {
      if (!v) {
        this.$router.replace("login");
      }
    }
  },
  mounted() {
    this.$store.dispatch("auth/loadUser");
  }
};
</script>

<style scoped>
.app-drawer {
  background-image: url(~@/assets/bg.jpg);
  background-position: -330px center;
  background-size: cover;
}
</style>
